<template>
  <div class="workshop-tab">
    <v-layout justify-space-between mb-3>
      <h2>Filtrer</h2>
      <v-btn @click="handlePrint">Imprimer l'édition atelier</v-btn>
    </v-layout>

    <!-- Filter block -->
    <v-layout class="filters-container" mb-8 wrap>
      <v-flex sm12>
        <v-layout justify-space-between>
          <v-flex sm4>
            <v-dialog v-model="dialogDatepickerFrom" width="290px">
              <template #activator="{ on }">
                <v-text-field
                  label="Du"
                  append-icon="mdi-calendar"
                  :value="dateFrom | dateFormat"
                  @click:clear="dateFrom = null"
                  v-on="on"
                  single-line
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="dateFrom"
                @change="dialogDatepickerFrom = false"
              >
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex sm4>
            <v-dialog
              v-if="dateType !== 'DETAIL_DAY_OPERATIONS'"
              v-model="dialogDatepickerTo"
              width="290px"
            >
              <template #activator="{ on }">
                <v-text-field
                  label="Au"
                  append-icon="mdi-calendar"
                  v-if="dateType !== 'DETAIL_DAY_OPERATIONS'"
                  :value="dateTo | dateFormat"
                  @click:clear="dateTo = null"
                  v-on="on"
                  single-line
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="dateTo"
                @change="dialogDatepickerTo = false"
              >
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex sm4>
            <v-btn class="mt-4" block @click="onSearch">Rechercher</v-btn>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex sm4>
            <v-select
              label="Type de date"
              v-model="dateType"
              :items="dateTypes"
              @change="cleanDate"
              filled
              hide-details
            ></v-select>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-data-table
      :headers="headersOverview"
      :items="projects"
      group-by="name"
      fixed-header
      height="500"
      :items-per-page="300"
      v-if="dateType == 'PERIOD_OVERVIEW'"
    >
      <!-- Total fabriqué -->
      <template #item.total_manufactured_cost="{value}">
        {{ value | currency }}
      </template>

      <template #group.header="{ group, items }">
        <td class="text-start">{{ group }}</td>
        <td class="text-start" style="text-align: left !important">
          {{ calculateTotalCost(items, "total_manufactured_cost") | currency }}
        </td>
      </template>
    </v-data-table>

    <v-data-table
      :headers="headersDetailedOperations"
      :items="filteredProjects"
      group-by="agency_name"
      fixed-header
      height="500"
      :items-per-page="300"
      v-if="dateType == 'DETAIL_DAY_OPERATIONS'"
    >
      <!-- Cost -->
      <template #item.manufactured_cost="{value}">
        {{ value | currency }}
      </template>

      <template #group.header="{ group, items }">
        <td class="text-start" colspan="6">{{ group }}</td>
        <td class="text-start" style="text-align: left !important" colspan="2">
          {{ calculateTotalCost(items, "manufactured_cost") | currency }}
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import PrintRepo from "@/repositories/print";
  import ProjectsRepo from "@/repositories/projects";

  export default {
    name: "WorkshopTab",
    data() {
      return {
        // Headers for detailed operations
        headersDetailedOperations: [
          {
            text: "N° Dossier",
            align: "left",
            value: "file_number"
          },

          {
            text: "Nom du patient",
            align: "left",
            value: "patient_fullname"
          },

          {
            text: "Type",
            align: "left",
            value: "device_label"
          },

          {
            text: "Support",
            align: "left",
            value: "bracket_label"
          },

          {
            text: "Technicien",
            align: "left",
            value: "manpower_fullname"
          },

          {
            text: "temps",
            align: "left",
            value: "estimated_finishing_time"
          },

          {
            text: "Coût",
            align: "left",
            value: "manufactured_cost"
          },

          {
            text: "Applicateur",
            align: "left",
            value: "applicator_fullname"
          }
        ],

        // Headers for overview
        headersOverview: [
          {
            text: "Opération",
            align: "left",
            value: "operation_label"
          },

          {
            text: "Total fabriqué",
            align: "left",
            value: "total_manufactured_cost"
          }
        ],

        projects: [],

        // Search
        dialogDatepickerFrom: false,
        dateFrom: null,
        dialogDatepickerTo: false,
        dateTo: null,

        dateType: "PERIOD_OVERVIEW",
        dateTypes: [
          {
            value: "PERIOD_OVERVIEW",
            text: "Synthèse de la période (Sur la date de Coût)"
          },
          {
            value: "DETAIL_DAY_OPERATIONS",
            text:
              "Détail des opérations du jour (ne prend en compte de la date de début)"
          }
        ]
      };
    },

    computed: {
      filteredProjects() {
        if (this.dateType !== "DETAIL_DAY_OPERATIONS") return null;

        return this.projects.map(item => {
          item.applicator_fullname = `${item.applicator_lastname.toUpperCase()} ${
            item.applicator_firstname
          }`;

          item.patient_fullname = `${item.patient_lastname} ${item.patient_firstname}`;
          item.manpower_fullname = `${item.manpower_name} ${item.manpower_firstname}`;

          return item;
        });
      }
    },
    methods: {
      /**
       * Reset some fields when we change date ty
       */
      cleanDate() {
        this.dateFrom = null;
        this.dateTo = null;
        this.projects = [];
      },

      /**
       * Search projects by date range
       */
      async onSearch() {
        const options = {
          dateType: this.dateType,
          dateFrom: this.dateFrom || null,
          dateTo: this.dateTo || new Date().toISOString().split("T")[0]
        };

        const { data } = await ProjectsRepo.fetchWorkshopProjects(options);
        this.projects = data;
      },

      /**
       * Sum prop value in an array of items
       *
       *  @param {Array} items
       */
      calculateTotalCost(items, prop) {
        return items.reduce((a, b) => a + (b[prop] || 0), 0);
      },

      // Download workshop pdf
      async handlePrint() {
        const params = {
          dateType: this.dateType,
          dateFrom: this.dateFrom || null,
          dateTo: this.dateTo || new Date().toISOString().split("T")[0]
        };

        try {
          const res = await PrintRepo.getWorkshopPdf(params);
          let blob = new Blob([res], {
            type: "application/pdf"
          });

          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);

          const date = new Date().toISOString().split("T")[0];
          const hour = new Date().toISOString().split("T")[1];
          const filename = `${date}-${hour}-atelier.pdf`;

          link.download = filename;
          link.click();
        } catch (error) {
          console.error(error);
        }
      }
    }
  };
</script>

<style></style>
